/**
 * @class away.partition.Partition
 */
var PartitionBase = (function () {
    function PartitionBase(root) {
        this._abstractionPool = new Object();
        this._updateQueue = {};
        this._root = root;
    }
    Object.defineProperty(PartitionBase.prototype, "root", {
        get: function () {
            return this._root;
        },
        enumerable: true,
        configurable: true
    });
    PartitionBase.prototype.getAbstraction = function (entity) {
        return (this._abstractionPool[entity.id] || (this._abstractionPool[entity.id] = new PartitionBase._abstractionClassPool[entity.assetType](entity, this)));
    };
    /**
     *
     * @param image
     */
    PartitionBase.prototype.clearAbstraction = function (entity) {
        this._abstractionPool[entity.id] = null;
    };
    PartitionBase.prototype.traverse = function (traverser) {
        this.updateEntities();
        if (this._rootNode)
            this._rootNode.acceptTraverser(traverser);
    };
    PartitionBase.prototype.invalidateEntity = function (entity) {
        this._updateQueue[entity.id] = entity;
    };
    PartitionBase.prototype.updateEntity = function (entity) {
        entity._iInternalUpdate();
        if (entity.isEntity)
            this.updateNode(this.getAbstraction(entity));
    };
    PartitionBase.prototype.updateNode = function (node) {
        var targetNode = this.findParentForNode(node);
        if (node.parent != targetNode) {
            if (node.parent)
                node.parent.iRemoveNode(node);
            targetNode.iAddNode(node);
        }
    };
    PartitionBase.prototype.clearEntity = function (entity) {
        delete this._updateQueue[entity.id];
        if (entity.isEntity)
            this.clearNode(this.getAbstraction(entity));
    };
    PartitionBase.prototype.clearNode = function (node) {
        if (node.parent) {
            node.parent.iRemoveNode(node);
            node.parent = null;
        }
    };
    /**
     *
     * @param entity
     * @returns {away.partition.NodeBase}
     */
    PartitionBase.prototype.findParentForNode = function (node) {
        return this._rootNode;
    };
    PartitionBase.prototype.updateEntities = function () {
        var entity;
        //required for controllers with autoUpdate set to true and queued events
        for (var key in this._updateQueue)
            this.updateEntity(this._updateQueue[key]);
        //clear updateQueue
        this._updateQueue = {};
    };
    PartitionBase.prototype.dispose = function () {
        //TODO
    };
    /**
     *
     * @param imageObjectClass
     */
    PartitionBase.registerAbstraction = function (entityNodeClass, assetClass) {
        PartitionBase._abstractionClassPool[assetClass.assetType] = entityNodeClass;
    };
    return PartitionBase;
}());
export { PartitionBase };
PartitionBase._abstractionClassPool = new Object();



// WEBPACK FOOTER //
// ../dist/lib/partition/PartitionBase.js